import React, { Component } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Stack,
  Tooltip,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import {
  PRODUCT_FILTER_KEY,
  getStoredProductFilters,
} from '../util/productFilters';

class ProductFilterModal extends Component {
  state = {
    filters: {
      productName: '',
      nappiCode: '',
      characteristic1: '',
      characteristic2: '',
    },
    initialFilters: null,
  };

  componentDidMount() {
    const storedFilters = getStoredProductFilters();
    this.setState({
      filters: storedFilters,
      initialFilters: storedFilters,
    });
  }

  handleChange = (field) => (event) => {
    this.setState((prev) => ({
      filters: {
        ...prev.filters,
        [field]: event.target.value,
      },
    }));
  };

  handleSubmit = () => {
    const { filters, initialFilters } = this.state;
    const { onClose, onChanged } = this.props;

    const filtersChanged =
      JSON.stringify(filters) !== JSON.stringify(initialFilters);

    // persist filters
    localStorage.setItem(
      PRODUCT_FILTER_KEY,
      JSON.stringify(filters)
    );

    // notify only if changed
    if (filtersChanged && typeof onChanged === 'function') {
      onChanged(filters);
    }

    onClose();
  };

  render() {
    const { open, onClose } = this.props;
    const { filters } = this.state;

    const toolbarSubs = (
      <Toolbar variant="dense">
        <Tooltip title="Close Modal" placement="top">
         <IconButton
          autoFocus
          edge="start"
          color="inherit"
          onClick={this.handleSubmit}
          aria-label="close"
          size="large">
          <CloseIcon />
         </IconButton>
        </Tooltip>
        <Typography variant="h6">
          <DialogTitle>Filter Products</DialogTitle>
        </Typography>
      </Toolbar>
    )
    
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>        

        { toolbarSubs }
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              label="Product Name"
              fullWidth
              value={filters.productName}
              onChange={this.handleChange('productName')}
            />

            <TextField
              label="Nappi Code"
              fullWidth
              value={filters.nappiCode}
              onChange={this.handleChange('nappiCode')}
            />

            <TextField
              label="Product Characteristic 1"
              fullWidth
              value={filters.characteristic1}
              onChange={this.handleChange('characteristic1')}
            />

            <TextField
              label="Product Characteristic 2"
              fullWidth
              value={filters.characteristic2}
              onChange={this.handleChange('characteristic2')}
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={this.handleSubmit}>
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ProductFilterModal;